import { FC, useEffect, useRef, useState } from 'react'
import {
    Link
} from "react-router-dom";
import Breadcrumb from '../../../Components/Breadcrumb';


import { Formik, Field, Form, FormikProps } from 'formik'
import * as yup from 'yup';
import ConfigurationService from '../service';

import Right from "../../../Models/Right"

import DataTable from 'react-data-table-component';

import Alert from '../../../Components/Alert';
import { useAppDispatch, useAppSelector } from '../../../Hooks/customSelector';


// type FormValues = Right;

//Alert
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; 
import { useTranslation } from 'react-i18next';

const RightPage: FC = () => {  

    // const alert = useAppSelector((state: RootState ) => state.alerts );
    const dispatch = useAppDispatch();
    const { t, i18n } = useTranslation();
    const formRef = useRef< FormikProps<Right>>(null);

    const [
        loading, setLoading
    ] = useState(false);

    const [
        rights,
        setRights
    ] = useState([]);

    const initialSelectedRight: any = null

    const [
        selectedRight,
        setSelectedRight
    ] = useState(initialSelectedRight);

    const [
        deleteLoading, setDeleteLoading
    ] = useState(false);

   const id: Number = 0;
    const [
        deleteId, setDeleteId
    ] = useState(id);


    const configService = new ConfigurationService();

    const deleteRight = async (rightId: Number) => {
        setDeleteId(rightId);
        setDeleteLoading(true);

        confirmAlert({
            overlayClassName: "alert-overlay",
            customUI: ({ onClose }) => {
              return (
                    <Alert 
                        alert={{
                            title: t('Confirmer'),
                            message: `${t('Vous confirmez la suppression de ce droit ?')}`,
                            actionText: `${t('Valider')}`,
                            action: async () => {
                                await configService.deleteRight(rightId).then(async function (response: any) {
                                    console.log(response); 
                                    confirmAlert({
                                        overlayClassName: "alert-overlay",
                                        customUI: ({ onClose }) => {
                                          return (
                                                <Alert 
                                                    alert={{
                                                        title: t('Succès'),
                                                        message: `${ t('Droit supprimé avec succès') }`,
                                                        actionText: 'Ok',
                                                        action: () => {
                                                            onClose();
                                                        }
                                                    }}
                                                />
                                          );
                                        }
                                    });
                                    getRights();
                                    setDeleteLoading(false); 
                                })
                                  .catch(function (error: any) {
                                    console.log(error);
                                    setDeleteLoading(false); 
                                });
                                onClose();
                            },
                            cancelText: "Annuler",
                            cancelAction: () => {
                                setDeleteLoading(false); 
                                onClose();
                            }
                        }}
                    />
              );
            }
        });

    }

    const getRights = () => {
        setLoading(true);
        configService.getRights().then(async function (response: any) {
            console.log(response); 
            setRights(response.data);
            setLoading(false); 
        })
          .catch(function (error: any) {
            console.log(error);
            setLoading(false); 
        });
    }

    const columns = [
        {
            name: 'Id',
            selector: (row: any) => row.id
        },
        {
            name: t('Libellé'),
            selector: (row: any) => row.libDroit,
        },
        {
            name: t('Description'),
            selector: (row: any) => row.descriptionDroit,
        }, 
        {
            name: "Options", 
            selector: (row: any) => (
                <div className='btn-list'>
                    <button type="button" onClick={event => {
                        setSelectedRight( Right.fromJson(row) );
                        if ( formRef.current != null) {
                            formRef.current.values.id = row.id;
                            formRef.current.values.libDroit =  row.libDroit;
                            formRef.current.values.descriptionDroit = row.descriptionDroit;
                        }  
                    }}
                        className="btn waves-effect waves-light btn-success">
                            <span className="" style={{ fontSize: "1em" }} >
                                <i className="icon-pencil"></i></span>
                    </button>
                    <button type="button" onClick={event => { deleteRight(row.id)  }}
                        className="btn waves-effect waves-light btn-danger">
                            {
                                deleteId == row.id && deleteLoading ?
                                <div className="spinner-border text-light spinner-border-sm" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div> :
                                <span className="" style={{ fontSize: "1em" }} >
                                <i className="icon-trash"></i></span>
                            }
                    </button>
                </div>
            )
        }
    ];
    

    const cancel = () => {

        setSelectedRight(null);

        if ( formRef.current != null) { 

            formRef.current.values.id = null;
            formRef.current.values.libDroit =  '';
            formRef.current.values.descriptionDroit = '';

        }
    }



    useEffect(() => {
        getRights();
    }, []);



    return ( 
        <>  
            <Breadcrumb />

            <div className="container-fluid">

                <div className="row">
                    <div className="col-md-5">
                        <div className="card">
                            <div className="card-body">

                                <h4 className="card-title">
                                    {
                                        selectedRight == null ? 
                                        t("Ajouter un droit") :
                                        t("Mettre à jour droit")
                                    }
                                </h4>

                                <Formik
                                    initialValues={
                                        {
                                        id: null,
                                        libDroit: '',
                                        descriptionDroit: ''
                                    }}
                                    validationSchema={
                                        yup.object().shape({
                                            libDroit: yup
                                                .string() 
                                                .required(`${t('Ce champ est obligatoire')}`),
                                            descriptionDroit: yup
                                                .string()
                                        })
                                    }
                                    onSubmit={async (
                                        values 
                                    ) => {

                                        setLoading(true);

                                        if(selectedRight == null) {

                                            await configService.postRight( Right.fromJson(values) ).then(async function (response: any) {
                                                console.log(response);

                                                confirmAlert({
                                                    overlayClassName: "alert-overlay",
                                                    customUI: ({ onClose }) => {
                                                      return (
                                                            <Alert 
                                                                alert={{
                                                                    title: 'Succès',
                                                                    message: 'Droit créé avec succès',
                                                                    actionText: 'Ok',
                                                                    action: () => {
                                                                        onClose();
                                                                    }
                                                                }}
                                                            />
                                                      );
                                                    }
                                                }); 
                                                 
                                                if ( formRef.current != null) {
                                                    formRef.current.values.id = null;
                                                    formRef.current.values.libDroit =  '';
                                                    formRef.current.values.descriptionDroit = '';
                                                } 
                                                getRights();
                                                setLoading(false); 
                                            })
                                            .catch(function (error: any) {
                                                setLoading(false); 
                                            });

                                        }  else {

                                            await configService.updateRight( Right.fromJson(values) ).then(async function (response: any) {
                                                console.log(response); 
                                                confirmAlert({
                                                    overlayClassName: "alert-overlay",
                                                    customUI: ({ onClose }) => {
                                                      return (
                                                            <Alert 
                                                                alert={{
                                                                    title: 'Succès',
                                                                    message: 'Droit mis à jour avec succès',
                                                                    actionText: 'Ok',
                                                                    action: () => {
                                                                        onClose();
                                                                    }
                                                                }}
                                                            />
                                                      );
                                                    }
                                                }); 

                                                if ( formRef.current != null) {
                                                    formRef.current.values.id = null;
                                                    formRef.current.values.libDroit =  '';
                                                    formRef.current.values.descriptionDroit = '';
                                                } 

                                                setSelectedRight(null);

                                                getRights();
                                                setLoading(false); 
                                            })
                                            .catch(function (error: any) {
                                                setLoading(false); 
                                            });

                                        }
                                        
                                    }} 
                                    innerRef={formRef}
                                    >
                                        {({ dirty, errors, touched, isValid, handleChange, handleBlur, handleSubmit, values }) => (
                                                    <Form>
                                                        <div className="form-body">
                                                            <label> 
                                                                { t('Libellé') } </label>
                                                            <div className="row">
                                                                
                                                                <div className="col-md-12">
                                                                    <div className="form-group">
                                                                        <input type="text"
                                                                            className={`form-control ${ errors.libDroit && touched.libDroit ? "is-invalid":""}`}
                                                                            id="libDroit" 
                                                                            name="libDroit" 
                                                                            onChange={handleChange('libDroit')}
                                                                            onBlur={handleBlur('libDroit')}
                                                                            value={values.libDroit}
                                                                            placeholder={ t('Libellé') ?? ''} />
                                                                        { errors.libDroit && touched.libDroit && errors.libDroit && 
                                                                        <div id="validationServer05Feedback" className="invalid-feedback">
                                                                            { errors.libDroit && touched.libDroit && errors.libDroit }
                                                                        </div> }
                                                                    </div>
                                                                </div>
                                                            </div> 

                                                            <label> { t('Description') } </label>
                                                            <div className="row">
                                                                
                                                                <div className="col-md-12">
                                                                    <div className="form-group">
                                                                        <textarea rows={6}
                                                                            className={`form-control ${ errors.descriptionDroit && touched.descriptionDroit ? "is-invalid":""}`}
                                                                            id="descriptionDroit" 
                                                                            name="descriptionDroit" 
                                                                            onChange={handleChange('descriptionDroit')}
                                                                            onBlur={handleBlur('descriptionDroit')}
                                                                            value={values.descriptionDroit}
                                                                            placeholder={ t('Description')  ?? ''} />
                                                                        { errors.descriptionDroit && touched.descriptionDroit && errors.descriptionDroit && 
                                                                        <div id="validationServer05Feedback" className="invalid-feedback">
                                                                            { errors.descriptionDroit && touched.descriptionDroit && errors.descriptionDroit }
                                                                        </div> }
                                                                    </div>
                                                                </div>
                                                            </div> 

                                                        </div>

                                                        <div className="form-actions">
                                                            <div className="text-right">
                                                                <button  disabled={!isValid} type="submit" 
                                                                    className="btn btn-info">
                                                                    { t('Valider') }
                                                                    {
                                                                        loading && <div className="spinner-border text-light spinner-border-sm" role="status">
                                                                            <span className="sr-only">Loading...</span>
                                                                        </div>
                                                                    }
                                                                </button>
                                                                <button type="button"
                                                                    onClick={event => cancel() }
                                                                    className="btn btn-dark">
                                                                        { t('Annuler') }
                                                                    </button>
                                                            </div>
                                                        </div>

                                                    </Form>
                                              )}
                                    </Formik>

                            </div>
                        </div>
                    </div>
                    <div className="col-md-7">
                        <div className="card">
                            <div className="card-body">
                                <h4 className="card-title">
                                    { t('Liste Droits') }
                                </h4>
                                <div className="btn-list">
                                    <button type="button" onClick={ event => getRights() }
                                        className="btn waves-effect waves-light btn-success">
                                            { t('Actualiser') }
                                        </button>
                                </div> 
                                <div className="table-responsive">
                                    <DataTable
                                        responsive={true}
                                        className="table table-striped table-bordered"
                                        columns={columns}
                                        data={rights}
                                        progressPending={loading}
                                        pagination
                                    />
                                </div>
                             </div>
                        </div> 
                    </div> 
                </div>

            </div>   
        </>                   
    );
}

export default RightPage